// extracted by mini-css-extract-plugin
export default {"Root":"game_Root__bmg2x"};